export type DeliveryServiceVendorsType = keyof typeof DeliveryServiceVendors;

/**
 * 벤더 택배사 정보
 */
export enum DeliveryServiceVendors {
  /**
   *  우체국 소포
   */
  KOREA_POST = "우체국 소포",
  /**
   *  CJ대한통운
   */
  CJ = "CJ대한통운",
  /**
   *  롯데택배
   */
  LOTTE = "롯데택배",
  /**
   *  한진택배
   */
  HANJIN = "한진택배",
  /**
   *  로젠택배
   */
  LOGEN = "로젠택배",
  /**
   *  경동택배
   */
  KYOUNGDONG = "경동택배",
  /**
   *  현대 글로비스
   */
  GLOVIS = "현대 글로비스",
  /**
   * LX 판토스
   */
  LXPANTOS = "LX 판토스",
  /**
   * 대신택배,
   */
  DAESIN = "대신택배",
  /**
   * ACI EXPRESS
   */
  ACIEXPRESS = "ACI EXPRESS",
  /**
   *  고려택배
   */
  GORYEO = "고려택배",
  /**
   *  TALAS
   */
  TALAS = "TALAS",
  /**
   *  천일택배
   */
  CHUNIL = "천일택배",
  /**
   * 용마로직스
   */
  YONGMALOGIS = "용마로직스",
  /**
   *  성화기업택배
   */
  SUNGHWA = "성화기업택배",
  /**
   *  케이호남택배
   */
  K_HONAM = "케이호남택배",
  /**
   *  SLX 로지스
   */
  SLX = "SLX 로지스",
  /**
   *  건영택배
   */
  KUNYOUNG = "건영택배",
  /**
   *  기타
   */
  ETC = "기타",
}
